module.exports = __webpack_public_path__ + "img/icon_poster.d65597ac.png";